import { ISODateType } from '@principle-theorem/shared';
import {
  AccInvoiceBillingMethod,
  AccInvoicePaymentStatus,
  AccInvoiceProcessingStatus,
} from './acc-invoice-enums';
import { AccDateTimeFormat } from '../acc';

export interface IAccInvoice {
  invoiceId?: string;
  pmsSoftwareName: string;
  pmsSoftwareVersion: string;
  vendor: IAccInvoiceVendor;
  comment?: string;
  lines: IAccLineItem[];
  contractId?: string;
  declaration: IAccInvoiceDeclaration;
}

export interface IAccInvoiceVendor {
  vendorName: string;
  vendorID: string;
  vendorGST?: string;
  vendorPhone?: string;
}

export interface IAccInvoiceStatus {
  claimNumber?: string;
  claimedAmount?: number;
  comments?: string;
  invoiceNumber?: string;
  processingStatus?: AccInvoiceProcessingStatus;
  scheduleId?: string;
  submittedOn?: AccDateTimeFormat;
  vendorId?: string;
}

export interface IAccInvoiceStatusDetails {
  awarded?: number;
  claimNumber?: string;
  claimed?: number;
  claimedAmount?: number;
  compensationDeduction?: number;
  compensationTotalAmount?: number;
  paymentDate?: ISODateType;
  paymentReference?: string;
  paymentStatus?: AccInvoicePaymentStatus;
  providerId?: string;
  scheduleId?: number;
  scheduleLineId?: number;
  serviceCode?: string; // comma-separated: "DG1,DG2"
  serviceDate?: ISODateType;
  statusReason?: string;
  withholdingTax?: number;
}

export interface IAccInvoiceDeclaration {
  declarationDate: ISODateType;
}

export interface IAccLineItem {
  claimId: string;
  accidentDate?: ISODateType;
  lineDetails?: IAccLineDetails;
  patient?: IAccInvoicePatientDetails;
  provider?: IAccInvoiceProviderDetails;
}

export interface IAccLineDetails {
  serviceCodes: string[]; // 1-5 ACC service codes, valid for the contract ID if any
  serviceDate: ISODateType;
  purchaseOrderNumber?: string; // 6-10 digits, if relevant
  billing: IAccBilling;
  invoiceComment?: string; // Extra details needed, e.g., tooth numbers for dental services
  invoiceAmount: number; // Amount claimed for this service line
}

export interface IAccBilling {
  billingMethod: AccInvoiceBillingMethod;
  hoursClaimed?: number; // Only for BillingMethod.Time
  minutesClaimed?: number; // Only for BillingMethod.Time, 0-59, hours or minutes must be > 0
  travelClaimed?: number; // Only for BillingMethod.Distance, whole km from 1 to 100,000
  unitsClaimed?: number; // Only for BillingMethod.Units, normally a whole number, 2 decimal places allowed
}

export interface IAccInvoicePatientDetails {
  nhi?: string;
  dateOfBirth?: ISODateType;
  firstName: string;
  middleName?: string;
  surname: string;
}

export interface IAccInvoiceProviderDetails {
  providerId?: string;
  firstName?: string;
  middleName?: string;
  surname?: string;
  facilityId?: string;
}

export interface IAccInvoiceBuilderClaimData {
  claimNumber: string;
  accidentDate?: ISODateType;
  patientDetails?: IAccInvoicePatientDetails;
  providerDetails?: IAccInvoiceProviderDetails;
  purchaseOrderNumber?: string;
}
